<template>
  <button
    class="btn btn-primary"
    :disabled="isSignInPending"
    @click.stop.prevent="toogleSignInOut">
    {{ signInProcess }}
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
import l from '@/vendor/logger'

export default {
  name: 'SignToggleBtn',

  computed: {
    ...mapGetters('user', [
      'isSignInPending',
      'userStatus',
      'user'
    ]),

    signInProcess () {
      l.d('signin/processing', this.userStatus)
      switch (this.userStatus) {
        case 'SIGN_IN': {
          return '로그아웃'
        }
        case 'SIGN_IN_FAILED':
        case 'SIGN_OUT': {
          return '로그인'
        }
        default: {
          return '진행중...'
        }
      }
    }
  },

  methods: {
    toogleSignInOut () {
      l.d('signin/togglesigninout', this.userStatus)
      switch (this.userStatus) {
        case 'SIGN_IN': {
          this.$store.dispatch('user/signOut')
          break
        }
        case 'SIGN_OUT': {
          this.$store.dispatch('user/signInGoogle')
          break
        }
        default: {
          throw new Error('auth/should_not_toogle_sign_in_and_out')
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
